import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Typography } from "@material-ui/core";

const OverflowTip = ({
  textToDisplay,
  toolipText,
  textStyle,
  textVariant,
  className,
  color,
  display
}) => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef();

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    setHover(textElementRef.current.scrollHeight > textElementRef.current.clientHeight);
  }, []);

  return (
    <Tooltip
      title={toolipText || textToDisplay}
      interactive
      disableHoverListener={!hoverStatus}
      style={{ fontSize: "2em" }}
    >
      <Typography
        ref={textElementRef}
        variant={textVariant}
        className={className}
        style={textStyle}
        display={display}
        color={color}
      >
        {textToDisplay}
      </Typography>
    </Tooltip>
  );
};

export default OverflowTip;
